/**
 * Helper function to convert camelCase keys to snake_case recursively
 *
 * @param obj - The object to convert
 * @returns The object with snake_case keys
 */
export function camelToSnakeCase(obj: any): any {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(camelToSnakeCase);
  }

  const result: any = {};
  for (const [key, value] of Object.entries(obj)) {
    const snakeKey = key.replace(
      /[A-Z]/g,
      (letter) => `_${letter.toLowerCase()}`
    );
    result[snakeKey] = camelToSnakeCase(value);
  }
  return result;
}

/**
 * Helper function to convert snake_case keys to camelCase recursively
 *
 * @param obj - The object to convert
 * @returns The object with camelCase keys
 */
export function snakeToCamelCase(obj: any): any {
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(snakeToCamelCase);
  }

  const result: any = {};
  for (const [key, value] of Object.entries(obj)) {
    const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
      letter.toUpperCase()
    );
    result[camelKey] = snakeToCamelCase(value);
  }
  return result;
}
